import htmlEscape from './htmlEscape'

export default function(value){
  if(!value){
    return value;
  }

  return (value < 100) ? htmlEscape(value.toString()) : "99<small>+</small>";
}